import './../styles.css';
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { Row, Col } from "antd";
//---project components
import { setVehicleDetails } from "reducers/eolSlice";
import { useRequiredAccess } from "hooks/useRequiredAccess"
import { getVehicleDetails } from 'apis/vehicleApis';
import { ORG_TYPES } from "components/Common/Constants";
import DaysPickerNew from "components/Common/DaysPickerNew";
import VehicleDetails from "components/Dashboard/VehicleDetails";
import Analytics from "./Analytics";
import DBLayout from 'components/Common/DBLayout';
import RealTimeDashboard from "./RealtimeDashboard";
import { setPageLoader } from 'reducers/loaderSlice';

const PageLayout = ({selectedMenu, pageTitle,}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    let startTime = dayjs().startOf('day').valueOf();
    let endTime = dayjs().valueOf();
    
    const [vehicle, setVehicle] = useState(location?.state?.vehId ? location?.state : null);
    const [selectedDateRange, setSelectedDateRange] = useState([startTime, endTime]);
    const [datePickerType, setDatePickerType] = useState('day');
    const [pickerOptions, setPickerOptions] = useState(['day', 'week', 'month', 'custom'])

    const checkAccess = useRequiredAccess(
        [],
        [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
    );

    const {
        data: vehicleDetailsData,
        isLoading: vehicleDetailsLoading,
        isError: vehicleDetailsIsError,
        error: vehicleDetailsError,
    } = useQuery({
        queryKey: ["vehicleDetails", vehicle?.vehImei],
        queryFn: () => getVehicleDetails(vehicle?.vehImei),
        retry: 1,
        keepPreviousData: true,
        enabled: !!(vehicle?.vehImei),
        staleTime: 10 * 60 * 1 * 1000,
    });
    
    const onChangeImei = (_, value) => {
        setVehicle(value);
    };
    
    const onChangeSelectedDateRange = (dateRange) => {
        console.log('changed...', dateRange)
        setSelectedDateRange(dateRange);
    }
    
    const onChangeDatePickerType = (dateType) => {
        setDatePickerType(dateType);
    }

    const onChangePickerOptions = (pickerOptions) => {
        setPickerOptions(pickerOptions)
    }

    useEffect(() => {
        if (selectedMenu === 'analytics'){
            setPickerOptions([]);
        } else if (selectedMenu === 'data') {
            setPickerOptions(['day']);
        } else if (selectedMenu === 'realtime') {
            dispatch(setPageLoader("live"))
        }
    }, [selectedMenu])

    useEffect(() => {
        checkAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    useEffect(() => {
        dispatch(setVehicleDetails(vehicleDetailsData));
          // eslint-disable-next-line
      }, [vehicleDetailsData, dispatch]);
    
    return(
        <div className='vaContainer'>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <div className='vaContents'>
                        <Row gutter={[16,16]}>
                            <Col span={24}>
                                <span style={{ fontSize: '24px', fontWeight: 600 }} >{pageTitle}</span>  
                            </Col>
                        </Row>
                        <Row gutter={[16,16]} style={{marginTop: '24px'}}>
                            <Col xs={24} sm={20} md={10} lg={10} xl={8}>
                                {/* {vehicleDetailsLoading && <Loading/>}
                                {vehicleDetailsIsError && <APIError message={vehicleDetailsError.message}/>}
                                {!vehicleDetailsLoading && vehicleDetailsData && */}
                                <VehicleDetails
                                    onChangeImei={onChangeImei}
                                    imei={vehicle}
                                    card={false}
                                    size={'small'}
                                    error={vehicleDetailsError?.message}
                                /> 
                                {/* } */}
                            </Col>
                            <Col xs={24} sm={24} md={14} lg={14} xl={16}>
                                {selectedMenu === 'analytics' &&
                                    <DaysPickerNew
                                        selectedDateRange={selectedDateRange}
                                        onChangeSelectedDateRange={onChangeSelectedDateRange}
                                        onChangeDatePickerType={onChangeDatePickerType}
                                        pickerOptions={pickerOptions}
                                    />
                                }
                                {selectedMenu === 'data' &&
                                    <DaysPickerNew
                                        selectedDateRange={selectedDateRange}
                                        onChangeSelectedDateRange={onChangeSelectedDateRange}
                                        onChangeDatePickerType={onChangeDatePickerType}
                                        pickerOptions={['day', 'week']}
                                    />
                                }
                                {selectedMenu === 'realtime' &&
                                    // <RealTimeRange
                                    //     onTimeFilterChange={onChangeSelectedDateRange}
                                    // />
                                    <></>
                                }
                            </Col>
                        </Row>
                        <Row gutter={[16,16]} style={{marginTop: '20px'}}> 
                            <Col span={24}>
                            {selectedMenu === 'analytics' && 
                                <Analytics
                                    selectedDateRange={selectedDateRange}
                                    datePickerType={datePickerType}
                                    pickerOptionChange={onChangePickerOptions}
                                />
                            }
                            {selectedMenu === 'data' && 
                                <DBLayout  // This is a common component for vehicle analytics and test ride analytics
                                    vehicle={vehicle}
                                    dateRange={selectedDateRange}
                                    // datePickerType={datePickerType}
                                    // pickerOptionChange={onChangePickerOptions}
                                />
                            }
                            {selectedMenu === 'realtime' && 
                                <RealTimeDashboard
                                    vehicle={vehicle}
                                    dateRange={selectedDateRange}
                                />
                            }
                            </Col>
                        </Row>                        
                    </div>
                </Col>
            </Row>
        </div>
    )

}

export default PageLayout;